import { getText } from 'i18n/intl';
import { type OutSyncMode } from '@timeedit/calendar-integration-api-contract';

const intlPrefix = 'integration.calendar.sync_settings.form.reminder';

export type ReminderFields = OutSyncMode['reminder'];

export type ReminderUiValue = 'default' | 'off' | number;

export function reminderFieldsToUiValue(
  reminder: ReminderFields | undefined
): ReminderUiValue {
  if (!reminder || reminder.behavior === 'USE_DEFAULT') return 'default';
  if (reminder.behavior === 'OFF') return 'off';
  return reminder.minutesBeforeStart ?? 0;
}

export function uiValueToReminderFields(
  uiValue: ReminderUiValue
): ReminderFields {
  if (uiValue === 'default') {
    return { behavior: 'USE_DEFAULT' };
  }
  if (uiValue === 'off') {
    return { behavior: 'OFF' };
  }
  return { behavior: 'ON', minutesBeforeStart: uiValue };
}

export const reminderOptions: Array<{ label: string; value: ReminderUiValue }> =
  [
    {
      label: getText(`${intlPrefix}.option.outlook_default`),
      value: 'default',
    },
    { label: getText(`${intlPrefix}.option.none`), value: 'off' },
    { label: getText(`${intlPrefix}.option.at_time_of_event`), value: 0 },
    { label: getText(`${intlPrefix}.option.five_minutes`), value: 5 },
    { label: getText(`${intlPrefix}.option.ten_minutes`), value: 10 },
    { label: getText(`${intlPrefix}.option.fifteen_minutes`), value: 15 },
    { label: getText(`${intlPrefix}.option.thirty_minutes`), value: 30 },
    { label: getText(`${intlPrefix}.option.one_hour`), value: 60 },
    { label: getText(`${intlPrefix}.option.one_day`), value: 1440 },
  ];
